import React from 'react';
import styles from '../../styles/BajaReactivacionStyles/BajaReactivacion.module.css';

function StudentResults({ students, onStudentSelect, loading, page, totalPages, onPageChange }) {
  if (loading) {
    return <div className={styles.noResults}><p>Cargando estudiantes...</p></div>;
  }

  if (!loading && students.length === 0) {
    return (
      <div className={styles.noResults}>
        <p>No se encontraron estudiantes con los criterios de búsqueda.</p>
      </div>
    );
  }

  const resolveNombre = (s) => s.nombre_completo || s.nombre || '—';
  const resolveCampus = (s) => {
    if (s.id_campus && typeof s.id_campus === 'object') return s.id_campus.nombre_campus || '—';
    return s.campus_nombre || s.campus || '—';
  };
  const resolveSeccion = (s) => {
    if (s.id_seccion && typeof s.id_seccion === 'object') return s.id_seccion.nombre_seccion || '—';
    return s.seccion_nombre || s.seccion || '—';
  };
  const resolvePrograma = (s) => {
    if (s.id_programa_actual && typeof s.id_programa_actual === 'object') return s.id_programa_actual.nombre_programa || '—';
    return s.programa_nombre || s.programa || '—';
  };
  const resolveEstatus = (s) => s.estatus_estudiante || s.estadoActual || s.estado || '—';

  return (
    <div className={styles.resultsContainer}>
      <div className={styles.resultsTable}>
        <div className={styles.tableHeader}>
          <div className={styles.headerCell}>Nombre</div>
          <div className={styles.headerCell}>Matrícula</div>
          <div className={styles.headerCell}>Campus</div>
          <div className={styles.headerCell}>Sección</div>
          <div className={styles.headerCell}>Programa</div>
          <div className={styles.headerCell}>Estatus</div>
        </div>
        
        <div className={styles.tableBody}>
          {students.map((student) => {
            const estatus = resolveEstatus(student);
            return (
              <div
                key={student.id_estudiante || student.id}
                className={styles.tableRow}
                onClick={() => onStudentSelect(student)}
              >
                <div className={styles.tableCell}>
                  <span className={styles.studentName}>{resolveNombre(student)}</span>
                </div>
                <div className={styles.tableCell}>{student.matricula || '—'}</div>
                <div className={styles.tableCell}>{resolveCampus(student)}</div>
                <div className={styles.tableCell}>{resolveSeccion(student)}</div>
                <div className={styles.tableCell}>{resolvePrograma(student)}</div>
                <div className={styles.tableCell}>
                  <span className={`${styles.statusBadge} ${
                    estatus === 'ACTIVO' ? styles.statusActive :
                    estatus === 'BAJA_TEMPORAL' ? styles.statusInactive :
                    estatus === 'BAJA_DEFINITIVA' ? styles.statusInactive :
                    styles.statusDefault
                  }`}>
                    {estatus}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Paginado */}
      {totalPages > 1 && (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 8, marginTop: 16 }}>
          <button
            className={styles.searchButton}
            style={{ padding: '6px 14px', fontSize: 13 }}
            onClick={() => onPageChange(page - 1)}
            disabled={page <= 1}
          >
            ← Anterior
          </button>
          <span style={{ fontSize: 13, color: '#374151' }}>
            Página {page} de {totalPages}
          </span>
          <button
            className={styles.searchButton}
            style={{ padding: '6px 14px', fontSize: 13 }}
            onClick={() => onPageChange(page + 1)}
            disabled={page >= totalPages}
          >
            Siguiente →
          </button>
        </div>
      )}
    </div>
  );
}

export default StudentResults;
